import * as yup from "yup";

const FormSchemaValidations = yup.object().shape({

  prodType: yup
    .mixed()
    .required("Este campo es obligatorio"),
  productCode: yup
    .string()
    .required("Este campo es obligatorio"),
  productName: yup.string().required("Este campo es obligatorio"),

  price: yup.string().required("Este campo es obligatorio"),
  
  description: yup.string().required("Este campo es obligatorio"),
  unitOfMeasure: yup
  .mixed()
  .required("Este campo es obligatorio")
});

export default FormSchemaValidations;
